import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface BranchState {
  branchName: string | null;
}

const initialState: BranchState = {
  branchName: null,
};

const branchSlice = createSlice({
  name: 'branch',
  initialState,
  reducers: {
    setBranchName(state, action: PayloadAction<string | null>) {
      state.branchName = action.payload;
    },
    clearBranchName(state) {
      state.branchName = null;
    },
  },
});

export const { setBranchName, clearBranchName } = branchSlice.actions;
export default branchSlice.reducer; 